/* ============================================================
   ÉKO '77 — Home: Catering, the tier count-up.

   Each .x-catering__tier-value holds a merchant-entered string like
   "500+" — a run of digits (commas allowed) followed by an optional
   suffix ("+", "%", …). The first time one scrolls into view it counts
   up from 0 to the digits, keeping the suffix static throughout, then
   snaps to the exact server-rendered string so no rounding ever drifts
   from what the merchant typed. A value with no leading digit (blank,
   "TBD", an emoji…) is left exactly as rendered — nothing to count.

   Runs once per element (IntersectionObserver, unobserve on trigger)
   and is idempotent across shopify:section:load, matching every other
   ÉKO script in this theme — editing a tier's number in the theme
   editor re-arms its count-up instead of stacking a second observer.

   prefers-reduced-motion: reduce -> skip the animation outright, the
   element already shows its final value from Liquid, so this is a
   no-op rather than a jump-cut.
   ============================================================ */
(function () {
  'use strict';

  if (window.__xCateringCount) return;
  window.__xCateringCount = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var DURATION = 1400;
  var observer = null;

  function ease(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animate(el, target, suffix, finalText) {
    var start = null;

    function tick(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / DURATION, 1);
      el.textContent = Math.round(ease(p) * target) + suffix;
      if (p < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = finalText;
      }
    }

    requestAnimationFrame(tick);
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);

      var el = entry.target;
      var finalText = el.textContent;
      var match = finalText.match(/^([\d,]+)(.*)$/);
      if (!match) return;

      var target = parseInt(match[1].replace(/,/g, ''), 10);
      if (isNaN(target)) return;
      if (reduced.matches) return; // finalText is already showing

      animate(el, target, match[2], finalText);
    });
  }

  function collect() {
    if (!observer) {
      if (!('IntersectionObserver' in window)) return;
      observer = new IntersectionObserver(onIntersect, { threshold: 0.4 });
    }

    var els = document.querySelectorAll('.x-catering__tier-value:not([data-x-counted])');
    els.forEach(function (el) {
      el.setAttribute('data-x-counted', '');
      observer.observe(el);
    });
  }

  document.addEventListener('shopify:section:load', collect);
  collect();
})();
